import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

import dict from "@/tools/dict";

export default {
  loadBusiData: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(newData, busiData) {
      var changeCSDCData, dictObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              changeCSDCData = _.get(busiData, "IMG_DATA.CHANGE_CSDC_INFO_LIST") || [];
              _context.next = 3;
              return dict.getDictData(["NATIONAL_ATTR", "ID_TYPE"]);

            case 3:
              dictObj = _context.sent;
              return _context.abrupt("return", new _Promise(function (resolve) {
                var NATIONAL_ATTR_INIT = "";
                var NATIONAL_ATTR_CHANGE = "";
                var changeCSDCData_INIT = "";
                var changeCSDCData_CHANGE = "";
                var USER_NAME_CHANGE = "";

                var contentNameObj = {
                  init: "",
                  change: ""
                };

                if (changeCSDCData.length) {
                  for (var i = 0; i < changeCSDCData.length; i++) {
                    var dataJSONObject = changeCSDCData[i];
                    var key = dataJSONObject.key;
                    var name = dataJSONObject.name;
                    var value = dataJSONObject.value;
                    var init = value.init;
                    var change = value.change;
                    if (["ID_TYPE2", "LEGAL_REP_ID_TYPE", "LINKMAN_ID_TYPE"].includes(key)) {
                      changeCSDCData_INIT += name + ":" + (dict.getDictText(init, dictObj["ID_TYPE"]) || init) + ",";
                      changeCSDCData_CHANGE += name + ":" + (dict.getDictText(change, dictObj["ID_TYPE"]) || change) + ",";
                    } else if ("NATIONAL_ATTR" === key) {
                      NATIONAL_ATTR_INIT = dict.getDictText(init, dictObj["NATIONAL_ATTR"]);
                      NATIONAL_ATTR_CHANGE = dict.getDictText(change, dictObj["NATIONAL_ATTR"]);
                    } else if (["ORG_SIMPLE_NAME"].includes(key)) {
                      USER_NAME_CHANGE = key;
                      contentNameObj.init = name + ":" + init + ";";
                      contentNameObj.change = name + ":" + change + ";";
                    } else {
                      changeCSDCData_INIT += name + ":" + init + ";";
                      changeCSDCData_CHANGE += name + ":" + change + ";";
                    }
                  }
                }
                newData.NATIONAL_ATTR_INIT = NATIONAL_ATTR_INIT;
                newData.NATIONAL_ATTR_CHANGE = NATIONAL_ATTR_CHANGE;

                newData.USER_NAME_CHANGE = USER_NAME_CHANGE;
                newData.CONTENT_NAME_INIT = contentNameObj.init;
                newData.CONTENT_NAME_CHANGE = contentNameObj.change;
                newData.changeCSDCData = {
                  changeCSDCData_INIT: changeCSDCData_INIT,
                  changeCSDCData_CHANGE: changeCSDCData_CHANGE
                };
                resolve(newData);
                return;
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function loadBusiData(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return loadBusiData;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/04x.js
// module id = 1132
// module chunks = 2